var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "btn-direction",
      class: [_vm.customClass, `btn-direction--${_vm.direction}`],
      attrs: { slot: _vm.customSlot, type: _vm.type },
      on: { click: _vm.handleClick },
      slot: _vm.customSlot,
    },
    [_c("Icon", { attrs: { icon: _vm.icon } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }